export const fluidEcsClientConfiguration = {
  host: 'https://config.edge.skype.com',
  clientName: 'Fluid',
  clientVersion: '0.0.0.1',
  teamNames: ['FluidExperiences']
};
